/**
 * Created by chachora on 11/28/18.
 */
import { combineReducers } from 'redux';
import { eventsReducer as events } from './events.reducer';
import airports from './airport.reducer';
import contacts from './contacts.reducer';
import rampServices from './ramp-services.reducer';
import statistics from './statistics.reducer';
import users from './users.reducer';
import notification from './notification.reducer';
import loading from './loading.reducer';

export const reducers = combineReducers({
  events,
  airports,
  contacts,
  rampServices,
  statistics,
  users,
  notification,
  loading,
});

export type RootState = ReturnType<typeof reducers>;
